<template>
  <div class="back">
    <span @click="backTo">
      {{ label }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      backTo: {
        type: Function,
        default: () => {}
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .back {
    text-align: initial;
    font-weight: normal;
    font-size: 12px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $light-blue-2;
    margin-bottom: 4px;
    cursor: pointer;
    span {
      &:hover {
        font-weight: bold;
      }
      &:before {
        content: '<';
        font-weight: bold;
        font-size: 12px;
        margin-right: 8px;
      }
    }
  }

</style>
